export default __webpack_public_path__ + "static/media/2.2f3806ae.jpg";